import { Navigate } from "react-router-dom";
import "../App.css";

// Ye component check karta hai ki admin logged in hai ya nahi
// Agar nahi hai toh /admin-login par redirect karta hai
export default function ProtectedRoute({ children }) {
  const isAuth = localStorage.getItem("adminAuth") === "true";
  return isAuth ? children : <Navigate to="/admin-login" replace />;
}
